import React, { FC } from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';
import { IGiftCardsProps } from '@/pages/gift-cards';

import { GiftCardSections } from './GiftCardSections';
import { GiftCardVideo } from './GiftCardVideo';
import { Hero } from './Hero';
import { PerfectDesignSection } from './PerfectDesignSection';

const RedeemGiftCardsTemplate: FC<IGiftCardsProps> = () => {
  return (
    <main>
      <Hero />
      <section id="video">
        <GiftCardVideo />
      </section>
      <section id="resones-why">
        <GiftCardSections />
      </section>
      <section className="bg-canvas-100" id="desings">
        <MaxWidth className="py-5 mx-auto">
          <PerfectDesignSection />
        </MaxWidth>
      </section>
    </main>
  );
};

export default RedeemGiftCardsTemplate;
